import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidate|History|Fulfillment|';
const sharedProps = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP' as LocPortal,
	feature: HubFeature.Credential,
};

export type SPCandidateFulfillmentLoc = 'SPCandidateFulfillmentTitle';

export const spCandidateFulfillmentLocs: LocDefs<SPCandidateFulfillmentLoc> = {
	SPCandidateFulfillmentTitle: {
		defaultValue: 'Fulfillments',
		displayType: 'Title',
		description: 'Title for the candidate fulfillments page.',
		displayPath: `${dpRoot}|Title`,
		...sharedProps,
		legacyName: 'Credential.Fulfillment/Candidates.Fulfillment.Title.PageSectionTitle',
	},
};

export const LOC_KEYS = MapLocKeys<SPCandidateFulfillmentLoc>(spCandidateFulfillmentLocs);
export type SPCandidateFulfillmentLocType = LocMap<SPCandidateFulfillmentLoc>;
